import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listKindergartens, Kindergarten } from "../../../lib/adminApi";
import { useToast } from "../../../components/Toast";

export default function KindergartensList() {
  const toast = useToast();
  const [items, setItems] = useState<Kindergarten[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      listKindergartens(search)
        .then(setItems)
        .catch((e) => toast.show("error", e.message))
        .finally(() => setLoading(false));
    }, 200);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Databáze školek</h1>
          <p className="mt-1 text-slate-600">
            Opakující se zákazníci. Nové školky se automaticky propojí při shodě e-mailu.
          </p>
        </div>
        <Link to="/admin/kindergartens/new" className="btn-primary">
          + Nová školka
        </Link>
      </div>

      <div className="mt-6">
        <input
          className="input max-w-md"
          placeholder="Hledat podle jména, města, e-mailu, IČO…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="mt-8 text-slate-500">Načítám…</div>
      ) : items.length === 0 ? (
        <div className="card mt-6 text-center text-slate-500">
          {search ? "Nic nenalezeno." : "Zatím žádná školka v databázi."}
        </div>
      ) : (
        <div className="mt-6 overflow-hidden rounded-xl border border-slate-200 bg-white">
          <table className="w-full text-sm">
            <thead className="border-b border-slate-200 bg-slate-50 text-xs uppercase text-slate-500">
              <tr>
                <th className="px-4 py-3 text-left">Školka</th>
                <th className="px-4 py-3 text-left">Město</th>
                <th className="px-4 py-3 text-left">Kontakt</th>
                <th className="px-4 py-3 text-right">Rezervací</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {items.map((kg) => (
                <tr key={kg.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3">
                    <div className="font-medium text-slate-900">{kg.name}</div>
                    {kg.ico && <div className="text-xs text-slate-500">IČO: {kg.ico}</div>}
                  </td>
                  <td className="px-4 py-3 text-slate-700">{kg.city}</td>
                  <td className="px-4 py-3">
                    <div className="text-slate-700">{kg.contactName}</div>
                    <div className="text-xs text-slate-500">{kg.contactEmail}</div>
                  </td>
                  <td className="px-4 py-3 text-right tabular-nums font-medium">
                    {kg._count?.reservations ?? 0}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Link
                      to={`/admin/kindergartens/${kg.id}`}
                      className="text-sm font-medium text-obloha-indigo-700 hover:text-obloha-indigo-900"
                    >
                      Detail →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
